export default (() => {

    return {
        encode(str: string): string {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
                String.fromCharCode(parseInt(`0x${p1}`))
            ));
        }
    }
})();